<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [disabled]="disabled"
    [required]="required"
    [placeholder]="placeholder"
    [compareWith]="compareByUuid"
    (selectionChange)="changeValue($event.value)"
    (openedChange)="onOpenedChange($event)"
    (keydown)="$event.stopPropagation()"
  >
    <mat-select-trigger>
      {{ getSelectedCityLabel() }}
    </mat-select-trigger>

    <mat-option disabled class="city-search-option">
      <div
        class="city-search-option__inner"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (keyup)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
      >
        <ngx-mat-select-search
          [formControl]="searchControl"
          placeholderLabel="Szukaj miejscowości..."
          noEntriesFoundLabel="Brak wyników"
          [searching]="loading"
          [clearSearchInput]="false">
        </ngx-mat-select-search>
      </div>
    </mat-option>

    <mat-option *ngIf="!required" [value]="null">
      Brak
    </mat-option>

    <mat-option
      *ngIf="!loading && (!searchControl.value || searchControl.value.trim().length < 2) && !selectedCity"
      disabled>
      Wpisz min. 2 znaki
    </mat-option>

    <mat-option *ngIf="loading" disabled>
      Szukam…
    </mat-option>

    <mat-option
      *ngFor="let city of cities"
      [value]="city.uuid"
    >
      <div class="city-option">
        <div class="city-option__name">
          {{ city.name }}
        </div>

        <div class="city-option__meta">
          {{ city.voivodeship }} / {{ city.district }} / {{ city.community }}
        </div>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
